import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/contacts.vue
var o = {
	name: "DtIconContacts",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--contacts"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Contacts",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 13 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2.333.667a.5.5 0 0 1 .5-.5h7.334a.5.5 0 0 1 0 1H2.833a.5.5 0 0 1-.5-.5ZM1.48 1.98a.5.5 0 0 1 .353-.147h9.334a.5.5 0 0 1 .5.5v7.334a.5.5 0 0 1-.5.5H1.833a.5.5 0 0 1-.5-.5V2.333a.5.5 0 0 1 .147-.353Zm.853.853v6.334h1V9a1.833 1.833 0 0 1 1.834-1.833h2.666A1.833 1.833 0 0 1 9.667 9v.167h1V2.833H2.333Zm6.334 6.334V9a.833.833 0 0 0-.834-.833H5.167A.833.833 0 0 0 4.333 9v.167h4.334Zm-2.167-2a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667Zm0-2.667a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm-4.167 6.833a.5.5 0 0 1 .5-.5H10.3a.5.5 0 1 1 0 1H2.833a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=contacts.js.map